module.exports = __webpack_public_path__ + "media/images/user/disclaimers/therapeutic_course-4bad972088f19360b6d83f9cd8d4f0ff.jpg";